import React from 'react';
import { PropTypes } from "prop-types";
import {	blue, red, messageType } from '../../../utils/constants'

const UserMessage = ({ message, type }) => (
	<div style={{ color: type === messageType.Warning ? red : blue, marginLeft:'20px', marginBottom:'15px', fontSize:'16px', lineHeight:'2' }}>
		<span><i className={type === messageType.Warning ? "fa fa-exclamation-triangle":"fa fa-check-circle"} aria-hidden="true" />
			&nbsp;&nbsp;{message}
		</span>
	</div>
);

UserMessage.propTypes ={
	message: PropTypes.string,
	type: PropTypes.string,
}

export default UserMessage;


// WEBPACK FOOTER //
// ./src/containers/userregistration/component/usermessage.js